import React from 'react'
import { FlexDiv } from '../../elements/NumberInput/NumberInputStyles'
import MultiplierInput from '../components/multiplierInput/MultiplierInput'
import WinChanceInput from '../components/winChanceInput/WinChanceInput'

interface Manual_inputs_props {
  handleMultiplier: any
  handleChance: any
  winchance: string
  multiplier: string
}
export default function ManualInputs({
  handleChance,
  multiplier,
  winchance,
  handleMultiplier,
}: Manual_inputs_props) {
  return (
    <FlexDiv marginBottom='15px'>
      <MultiplierInput handleMultiplier={handleMultiplier} value={multiplier} />
      <WinChanceInput handleChance={handleChance} value={winchance} />
    </FlexDiv>
  )
}
